<table class="table">
  <thead>
    <tr>
      <th>{{ "common.productName" | translate }}</th>
      <th>{{ "catalog.sku" | translate }}</th>
      <th>{{ "order.refund-quantity" | translate }}</th>
      <th>{{ "order.unit-price" | translate }}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let line of refundLinesResult">
      <td>
        <a
          (click)="close()"
          class="button-ghost"
          [routerLink]="[
            '/catalog/products',
            line.orderLine.productVariant.productId,
            'variants',
            line.orderLine.productVariant.id
          ]"
        >
          <span class="limit-name">
            {{ line.orderLine.productVariant.name }}
          </span>
          <clr-icon shape="arrow right" />
        </a>
      </td>

      <td>
        {{ line.orderLine.productVariant.sku }}
      </td>

      <td>
        {{ line.quantity }}
      </td>

      <td>
        {{ convertPrice(line.orderLine.unitPriceWithTax) }}
      </td>
    </tr>
  </tbody>
</table>
